// Fonction pour mettre à jour le montant dans le CTA
function updateFinancingCTAAmount() {
  const ctaAmountElement = document.querySelector('.financing-options-cta__amount');
  if (!ctaAmountElement) return;

  let smallestAmountFormatted = null;
  if (typeof window.younitedSmallestAmount !== 'undefined' && window.younitedSmallestAmount !== null) {
    smallestAmountFormatted = new Intl.NumberFormat().format(window.younitedSmallestAmount);
    ctaAmountElement.textContent = `${smallestAmountFormatted} €`;
  }
}

// Remplace la définition de window.younitedSmallestAmount par un setter personnalisé
const defineYounitedSmallestAmount = function (value) {
  window.younitedSmallestAmount = value;
  updateFinancingCTAAmount();
};

// Surcharge la définition originale de window.younitedSmallestAmount
const originalDefineProperty = Object.defineProperty;
Object.defineProperty(window, 'younitedSmallestAmount', {
  get: function () {
    return this._younitedSmallestAmount;
  },
  set: function (value) {
    this._younitedSmallestAmount = value;
    updateFinancingCTAAmount();
  },
  configurable: true,
});

// Initialisation
document.addEventListener('DOMContentLoaded', function () {
  // Mise à jour initiale
  updateFinancingCTAAmount();
});

// FMD Conditions Modal - Connect event to x-modal system
document.addEventListener('fmd:open-conditions-modal', () => {
  const fmdModal = document.querySelector('x-modal[data-modal-id="fmd-conditions"]');

  if (fmdModal && typeof fmdModal.open === 'function') {
    fmdModal.open();
  } else {
    // Fallback: trigger via class-based system
    const triggerButton = document.createElement('button');
    triggerButton.classList.add('x-button__fmd-conditions');
    triggerButton.style.display = 'none';
    document.body.appendChild(triggerButton);
    triggerButton.click();
    triggerButton.remove();
  }
});

// Close modal via "Compris" button
document.addEventListener('click', (e) => {
  if (e.target.matches('[data-fmd-conditions-close]')) {
    const fmdModal = document.querySelector('x-modal[data-modal-id="fmd-conditions"]');
    if (fmdModal && typeof fmdModal.close === 'function') {
      fmdModal.close();
    }
  }
});
